/** @jsxImportSource @emotion/react */

const SmartMatchMeterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_59_730)">
      <path
        d="M0.666748 7.33332H2.66675V8.66666H0.666748V7.33332ZM12.7334 2.33332L11.3334 3.73332L12.2667 4.66666L13.6667 3.26666L12.7334 2.33332ZM7.33342 0.666656H8.66675V2.66666H7.33342V0.666656ZM3.26675 2.33332L2.33341 3.26666L3.73341 4.66666L4.66675 3.73332L3.26675 2.33332ZM6.66675 14.6667C6.66675 15.0667 6.93341 15.3333 7.33342 15.3333H8.66675C9.06675 15.3333 9.33342 15.0667 9.33342 14.6667V14H6.66675V14.6667ZM8.00008 3.99999C5.80008 3.99999 4.00008 5.79999 4.00008 7.99999C4.00008 9.46666 4.80008 10.8 6.00008 11.4667V12.6667C6.00008 13.0667 6.26675 13.3333 6.66675 13.3333H9.33342C9.73341 13.3333 10.0001 13.0667 10.0001 12.6667V11.4667C11.2001 10.8 12.0001 9.46666 12.0001 7.99999C12.0001 5.79999 10.2001 3.99999 8.00008 3.99999ZM8.66675 10.6V11.3333H7.33342V10.6C6.20008 10.3333 5.33342 9.26666 5.33342 7.99999C5.33342 6.53332 6.53341 5.33332 8.00008 5.33332C9.46675 5.33332 10.6667 6.53332 10.6667 7.99999C10.6667 9.26666 9.80008 10.2667 8.66675 10.6ZM13.3334 7.33332H15.3334V8.66666H13.3334V7.33332Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_59_730">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SmartMatchMeterIcon;
